
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1RN2b", function(module, exports) {
const $d453ec9fb76ba7fd$export$9957974f8b4d8f74 = 'copyShareLink';
var $d453ec9fb76ba7fd$export$e82cf716cce37b4e = /*#__PURE__*/ function(PAGE_MODE) {
    PAGE_MODE["VIEW"] = "view";
    PAGE_MODE["EDIT"] = "edit";
    return PAGE_MODE;
}({});
module.exports["ACTION_SUBJECT_ID"] = $d453ec9fb76ba7fd$export$9957974f8b4d8f74;
module.exports["PAGE_MODE"] = $d453ec9fb76ba7fd$export$e82cf716cce37b4e;

});

parcelRegister("bPoXA", function(module, exports) {
$parcel$export(module.exports, "PAGE_MODE", () => (parcelRequire("1RN2b")).PAGE_MODE);

var $jmjWc = parcelRequire("jmjWc");


var $7VdCF = parcelRequire("7VdCF");


var $1RN2b = parcelRequire("1RN2b");


const $593a9a70400e9fe4$export$9d30156e45c09e81 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "VbFx8",
    name: "CopyLinkButtonLoader",
    loader: async ()=>{
        return (await (parcelRequire("jlS8S"))).CopyLink;
    },
    loading: (0, $7VdCF.CopyLinkButtonPlaceholder)
});
module.exports["CopyLinkButtonLoader"] = $593a9a70400e9fe4$export$9d30156e45c09e81;

});

parcelRegister("7VdCF", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kTb7m = parcelRequire("kTb7m");


var $7ZB0A = parcelRequire("7ZB0A");

const $e679cdda51869592$var$i18n = (0, $kSwu1.defineMessages)({
    copyLinkLabel: {
        id: "share-and-restrict-dialog.copylink.icon.label",
        defaultMessage: "Copy link"
    }
});
const $e679cdda51869592$export$1f3200a5b8d4d8e1 = ()=>{
    const $ = (0, $bDgLe.c)(4);
    const intl = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== intl) {
        t0 = intl.formatMessage($e679cdda51869592$var$i18n.copyLinkLabel);
        $[0] = intl;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            testId: "copy-link-button-placeholder",
            "data-test-id": "copy-link-button-placeholder",
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
                label: t0,
                spacing: "spacious"
            }),
            isDisabled: true
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
module.exports["CopyLinkButtonPlaceholder"] = $e679cdda51869592$export$1f3200a5b8d4d8e1;

});

parcelRegister("jlS8S", function(module, exports) {

let $e169fa03977d77ab$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e169fa03977d77ab$var$load("9RX5o").then(()=>parcelRequire('eB05M'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("c411D", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");

const $351b756af5d314b8$export$6654a9a4dc3a2802 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return $351b756af5d314b8$var$_temp;
} : ()=>{
    return (0, $cozmU.useCallback)((payload, type)=>{
        window.parent.postMessage({
            type: type,
            payload: payload
        }, '*');
    }, []);
};
function $351b756af5d314b8$var$_temp(payload, type) {
    window.parent.postMessage({
        type: type,
        payload: payload
    }, "*");
}
module.exports["useEmbeddedConfluenceEventMarkers"] = $351b756af5d314b8$export$6654a9a4dc3a2802;

});

parcelRegister("kymtV", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kcIQr = parcelRequire("kcIQr");


var $8aF6s = parcelRequire("8aF6s");


var $jBejw = parcelRequire("jBejw");


var $gsAuf = parcelRequire("gsAuf");

const $9bfe716549ab8714$export$1ec43e43e3a28820 = ()=>{
    const { createAndResolve: createAndResolve, loading: loading } = (0, $gsAuf.useCreatePagePdfExportTask)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    const startExport = (0, $cozmU.useCallback)(async ({ contentId: contentId, contentType: contentType, url: url, source: source = 'menu' })=>{
        const commonAttributes = {
            contentId: contentId,
            contentType: contentType ?? null,
            exportSource: source
        };
        // One track event per create attempt (funnel entry for every surface, including legacy which
        // opens no modal) carrying the resolved decision and backend error code. Shared by the
        // initial run and "Try again" so both are instrumented identically.
        const runCreate = async ()=>{
            const result = await createAndResolve(contentId, contentType);
            if (result.type === 'error') createEvent({
                type: 'sendTrackEvent',
                data: {
                    source: 'pagePdfExport',
                    action: 'failed',
                    actionSubject: 'pagePdfExportCreate',
                    attributes: {
                        ...commonAttributes,
                        decision: 'error',
                        reason: result.reason,
                        errorCode: result.errorCode ?? null,
                        statusCode: result.statusCode ?? null
                    }
                }
            }).fire();
            else createEvent({
                type: 'sendTrackEvent',
                data: {
                    source: 'pagePdfExport',
                    action: 'succeeded',
                    actionSubject: 'pagePdfExportCreate',
                    attributes: {
                        ...commonAttributes,
                        decision: result.type,
                        exportTaskId: result.type === 'modal' ? result.exportTaskId ?? null : null
                    }
                }
            }).fire();
            return result;
        };
        // Real "Try again": re-run the same create flow. Defined once here so the overflow menu and
        // the Cmd/Ctrl+P shortcut share identical retry behaviour. A legacy decision navigates to
        // the hidden-action URL as a side effect; the modal maps modal/error decisions itself.
        const onRetry = async ()=>{
            const retryDecision = await runCreate();
            if (retryDecision.type === 'legacy' && url) window.location.assign(url);
            return retryDecision;
        };
        const decision = await runCreate();
        switch(decision.type){
            case 'legacy':
                // V1/V2: navigate to the hidden-action URL when the caller provided one. Callers that
                // own their own legacy fallback (e.g. the print shortcut) omit `url`, and act on the
                // returned `legacy` decision instead.
                if (url) window.location.assign(url);
                break;
            case 'modal':
                showModal((0, $jBejw.PagePdfExportModal), {
                    contentId: contentId,
                    contentType: contentType,
                    exportTaskId: decision.exportTaskId,
                    source: source,
                    onRetry: onRetry
                });
                break;
            case 'error':
            default:
                // Open the modal in its built-in error state (null task id); "Try again" re-runs create.
                showModal((0, $jBejw.PagePdfExportModal), {
                    contentId: contentId,
                    contentType: contentType,
                    exportTaskId: null,
                    source: source,
                    onRetry: onRetry
                });
                break;
        }
        return decision;
    }, [
        createAndResolve,
        createEvent,
        showModal
    ]);
    return {
        startExport: startExport,
        loading: loading
    };
};
module.exports["useStartPagePdfExport"] = $9bfe716549ab8714$export$1ec43e43e3a28820;

});

parcelRegister("jBejw", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $e57c66f2698c5617$export$d106071c054f3436 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "1xkUz",
    name: "PagePdfExportModal",
    loader: async ()=>(await (parcelRequire("diSC0"))).PagePdfExportModal
});
module.exports["PagePdfExportModal"] = $e57c66f2698c5617$export$d106071c054f3436;

});

parcelRegister("diSC0", function(module, exports) {

let $9af7519a8320c87f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9af7519a8320c87f$var$load("6wr18"),
    $9af7519a8320c87f$var$load("dxcsb"),
    $9af7519a8320c87f$var$load("99ObF"),
    $9af7519a8320c87f$var$load("ffEVr"),
    $9af7519a8320c87f$var$load("oKrxj")
]).then(()=>parcelRequire('liWq5'));

});

parcelRegister("gsAuf", function(module, exports) {

var $fM8Mx = parcelRequire("fM8Mx");


var $cozmU = parcelRequire("cozmU");


var $5BvyC = parcelRequire("5BvyC");

var $8jDil = parcelRequire("8jDil");


var $308Wd = parcelRequire("308Wd");


var $bQm3c = parcelRequire("bQm3c");


var $b0AwI = parcelRequire("b0AwI");

/**
 * The `contentId` mutation input is typed `ID!` but the backend expects a type-specific Confluence
 * content ARI — `blogpost/…` for blogposts, `page/…` for everything else. Live docs are
 * `contentType === 'page'`, so they correctly resolve to a page ARI.
 */ const $01eed5ca3125a453$var$buildContentAri = (cloudId, contentId, contentType)=>contentType === 'blogpost' ? (0, $5BvyC.ConfluenceBlogpostAri).create({
        siteId: cloudId,
        blogpostId: contentId
    }).toString() : (0, $8jDil.ConfluencePageAri).create({
        siteId: cloudId,
        pageId: contentId
    }).toString();
const $01eed5ca3125a453$var$CREATE_PDF_EXPORT_TASK_MUTATION = (0, $fM8Mx.default);
const $01eed5ca3125a453$export$c9155252c3ac4484 = ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [createTask, { loading: loading }] = (0, $308Wd.useMutationInterop)($01eed5ca3125a453$var$CREATE_PDF_EXPORT_TASK_MUTATION, {
        __callerPackage__: "page-pdf-export"
    });
    const createAndResolve = (0, $cozmU.useCallback)(async (contentId, contentType)=>{
        let createResult;
        try {
            const result = await createTask({
                variables: {
                    contentId: $01eed5ca3125a453$var$buildContentAri(cloudId, contentId, contentType)
                }
            });
            const payload = result?.data?.confluence_createPdfExportTaskForSingleContent;
            createResult = payload ? {
                success: payload.success,
                exportVersion: payload.exportVersion,
                exportTaskId: payload.exportTaskId,
                errors: payload.errors?.map((error)=>({
                        message: error?.message ?? null,
                        extensions: error?.extensions ? {
                            errorType: error.extensions.errorType ?? null,
                            statusCode: error.extensions.statusCode ?? null
                        } : null
                    })) ?? null
            } : undefined;
        } catch (error) {
            createResult = undefined;
        }
        return (0, $b0AwI.resolvePagePdfExportCreateResult)({
            createResult: createResult,
            isExperimentEnabled: true
        });
    }, [
        createTask,
        cloudId
    ]);
    return {
        createAndResolve: createAndResolve,
        loading: loading
    };
};
module.exports["useCreatePagePdfExportTask"] = $01eed5ca3125a453$export$c9155252c3ac4484;

});

parcelRegister("fM8Mx", function(module, exports) {
/**
 * @generated SignedSource<<a3e608f92169bde9e02a07e39432e594>>
 * @relayHash 96dce17396b98402ea852d82fd7ba6ba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0cc26de84f1d64f1941793801db3e6df205067025012647431441512d2deafb8
const $3b0cc2b76685a2ca$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "exportTaskId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "exportVersion"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCreatePagePdfExportTaskMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceCreatePdfExportTaskForSingleContentPayload",
                    "kind": "LinkedField",
                    "name": "confluence_createPdfExportTaskForSingleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCreatePagePdfExportTaskMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceCreatePdfExportTaskForSingleContentPayload",
                    "kind": "LinkedField",
                    "name": "confluence_createPdfExportTaskForSingleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "96dce17396b98402ea852d82fd7ba6ba",
            "id": "0cc26de84f1d64f1941793801db3e6df205067025012647431441512d2deafb8",
            "metadata": {},
            "name": "useCreatePagePdfExportTaskMutation",
            "operationKind": "mutation",
            "text": "mutation useCreatePagePdfExportTaskMutation($contentId:ID!){confluence_createPdfExportTaskForSingleContent(input:{contentId:$contentId}){success,exportTaskId,exportVersion,errors{message,extensions{__typename,errorType,statusCode,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$3b0cc2b76685a2ca$var$node.hash = "744df54379316c281f95d3307db18404";
var $3b0cc2b76685a2ca$export$2e2bcd8739ae039 = $3b0cc2b76685a2ca$var$node;
module.exports["default"] = $3b0cc2b76685a2ca$export$2e2bcd8739ae039;

});

parcelRegister("b0AwI", function(module, exports) {
const $da9c7f91e4b9420f$export$3ccc38d5bb117541 = ({ createResult: createResult, isExperimentEnabled: isExperimentEnabled })=>{
    if (!createResult || createResult.success === false || Boolean(createResult.errors?.length)) {
        const errorCode = createResult?.errors?.map((error)=>error?.extensions?.errorType).find((value)=>Boolean(value)) ?? null;
        const statusCode = createResult?.errors?.map((error)=>error?.extensions?.statusCode).find((value)=>value != null) ?? null;
        return {
            type: 'error',
            reason: 'create-failed',
            errorCode: errorCode,
            statusCode: statusCode
        };
    }
    if (!isExperimentEnabled) return {
        type: 'legacy'
    };
    switch(createResult.exportVersion){
        case 'V1':
        case 'V2':
            return {
                type: 'legacy'
            };
        case 'V3':
            return {
                type: 'modal',
                exportTaskId: createResult.exportTaskId
            };
        default:
            return {
                type: 'error',
                reason: 'unsupported-export-version'
            };
    }
};
module.exports["resolvePagePdfExportCreateResult"] = $da9c7f91e4b9420f$export$3ccc38d5bb117541;

});

parcelRegister("dpqzw", function(module, exports) {
const $e10f62297c04a73f$export$51c8f3f20bd49804 = 'fabric-editor-popup-scroll-parent';
const $e10f62297c04a73f$export$547bf96576574b25 = '.ProseMirror > *';
const $e10f62297c04a73f$export$f76b40820c13783a = '.ak-renderer-document';
const $e10f62297c04a73f$export$7718f42d39a9217b = 'content';
module.exports["EDITOR_PARENT_CLASS"] = $e10f62297c04a73f$export$51c8f3f20bd49804;
module.exports["EDITOR_CHILDREN_SELECTOR"] = $e10f62297c04a73f$export$547bf96576574b25;
module.exports["RENDERED_CONTENT_SELECTOR"] = $e10f62297c04a73f$export$f76b40820c13783a;
module.exports["FABRIC_PAGE_CONTENT_ID"] = $e10f62297c04a73f$export$7718f42d39a9217b;

});

parcelRegister("gkIgp", function(module, exports) {
var $44e99c386783fe05$export$ea1a2a449eaeaa2d = /*#__PURE__*/ function(CollabServiceProperty) {
    CollabServiceProperty["NCS"] = "ncs";
    CollabServiceProperty["SYNCHRONY"] = "synchrony";
    return CollabServiceProperty;
}({});
module.exports["CollabServiceProperty"] = $44e99c386783fe05$export$ea1a2a449eaeaa2d;

});

parcelRegister("aYZaZ", function(module, exports) {
$parcel$export(module.exports, "Buttons", () => (parcelRequire("iQb1R")).Buttons);

var $jmjWc = parcelRequire("jmjWc");


var $6tSjb = parcelRequire("6tSjb");


var $iQb1R = parcelRequire("iQb1R");


const $ecc7cc41466863e8$export$82d507aca0e648e3 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ZRz6B",
    name: "EllipsisDropdownComponent",
    loader: async ()=>(await (parcelRequire("bqncX"))).EllipsisDropdownComponent,
    loading: (0, $6tSjb.EllipsisPlaceholder)
});
module.exports["EllipsisDropdownComponent"] = $ecc7cc41466863e8$export$82d507aca0e648e3;

});

parcelRegister("6tSjb", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $5SGpQ = parcelRequire("5SGpQ");


var $6TaGl = parcelRequire("6TaGl");

const $565f8db62106cdff$var$i18n = (0, $kSwu1.defineMessages)({
    more: {
        id: "editor-ellipsis-dropdown.placeholder.ellipsis.more",
        defaultMessage: "More"
    }
});
const $565f8db62106cdff$export$2edf2f3658d4e349 = ()=>{
    const intl = (0, $kSwu1.useIntl)();
    const label = intl.formatMessage($565f8db62106cdff$var$i18n.more);
    const moreIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
        color: "currentColor",
        spacing: "spacious",
        label: label
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5SGpQ.default), {
        testId: "ellipsis-placeholder",
        isDisabled: true,
        iconBefore: moreIcon,
        appearance: "subtle"
    });
};
module.exports["EllipsisPlaceholder"] = $565f8db62106cdff$export$2edf2f3658d4e349;

});

parcelRegister("bqncX", function(module, exports) {

let $8514200b8759cfa9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8514200b8759cfa9$var$load("6WNyl"),
    $8514200b8759cfa9$var$load("fky9A"),
    $8514200b8759cfa9$var$load("87mhv"),
    $8514200b8759cfa9$var$load("iY5MP")
]).then(()=>parcelRequire('3d2EW'));

});

parcelRegister("iQb1R", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ var $f15550a75cff81e6$export$665d5a662b7213f3 = /*#__PURE__*/ function(Buttons) {
    Buttons["DELETE_DRAFT"] = "delete-draft";
    Buttons["EDIT_LABELS"] = "edit-labels";
    Buttons["MOVE_PAGE"] = "move-page";
    Buttons["PREVIEW"] = "preview";
    Buttons["PUBLISH_WITHOUT_NOTIFY"] = "publish-without-notify";
    Buttons["RESOLVED_COMMENTS"] = "resolved-comments";
    Buttons["TEMPLATE_BROWSER"] = "template-browser";
    Buttons["VIEW_CHANGES"] = "view-changes";
    Buttons["EXPORT"] = "export";
    Buttons["ADVANCED"] = "advanced";
    Buttons["ARCHIVE"] = "archive";
    Buttons["ATTACHMENTS"] = "attachments";
    Buttons["SWITCH_TO_LIVE_EDIT"] = "switch-to-live-edit";
    Buttons["CLASSIFY_CONTENT"] = "classify-content";
    Buttons["MANAGE"] = "manage";
    Buttons["PRESENT"] = "presentation-mode";
    return Buttons;
}({});
module.exports["Buttons"] = $f15550a75cff81e6$export$665d5a662b7213f3;

});

parcelRegister("briGH", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $7W8i8 = parcelRequire("7W8i8");

const $8540b650e122e686$var$RETRY_STATUS_CODE = [
    409,
    412
];
const $8540b650e122e686$export$8e3b4758c0e0a83 = (response)=>response?.data?.experimentalMigratePages?.status;
const $8540b650e122e686$var$logger = (0, $7W8i8.getLogger)('PageMigration');
const $8540b650e122e686$export$9369b12211e1fce4 = (refetchContentHash, migratePages, retriesLeft = 3, interval = 1000, statusCodes = [])=>{
    return new Promise((resolve, reject)=>{
        // b/c contentHash is variable and could changed when user in preview
        // perform refetch to grab the latest contentHash (to avoid 412 and 409 error when performing migration)
        return refetchContentHash().then((contentHash)=>{
            migratePages(contentHash).then((response)=>{
                const status = $8540b650e122e686$export$8e3b4758c0e0a83(response);
                setTimeout(()=>{
                    if (retriesLeft === 1) {
                        const message = 'Number of retrying attempt reach maximum number of retries';
                        $8540b650e122e686$var$logger.debug`${message}`;
                        return reject(message, statusCodes);
                    }
                    // only retry when status code is 409, 412
                    if ($8540b650e122e686$var$RETRY_STATUS_CODE.indexOf(Number.parseInt(status)) !== -1) {
                        statusCodes.push(Number.parseInt(status));
                        $8540b650e122e686$export$9369b12211e1fce4(refetchContentHash, migratePages, retriesLeft - 1, interval, statusCodes).then(resolve, reject);
                    } else return resolve(response, statusCodes);
                }, interval);
            }).catch((error)=>{
                return reject(error, statusCodes);
            });
        });
    });
};
module.exports["getStatusFromResponse"] = $8540b650e122e686$export$8e3b4758c0e0a83;
module.exports["retry"] = $8540b650e122e686$export$9369b12211e1fce4;

});


//# sourceMappingURL=CreatePageContainer.6e337ac5.js.map
